import React from 'react'
import All_regesters from './Reg_folder/All_regesters'
import Regestered from './Reg_folder/Regestered';
import '../Work-css/All_regesters.css';

function Reg_link() {
  return (
    <div className='full_reg'>
        <div className='top'><All_regesters /></div>
        <div className='regesters'><Regestered /></div>
    </div>
  )
}

export default Reg_link
